import { Auth } from '@/_services/amplify.service.js'
export default {
  render () {
    return null
  },
  name: 'ShipmentsRouter',
  beforeRouteEnter (to, from, next) {
    Auth.currentSession().then((session) => {
      if (session.getIdToken().payload.org === 'ea22334c-25eb-4eb7-bc70-1f30a04d7544') {
        next('/shipments-new')
      } else {
        next('/shipments-by-day')
      }
    })
  }
}
